import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import SectionMessage from '@atlaskit/section-message';
import { Section } from '@atlaskit/side-navigation';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const StarredFiltersErrorFallback = () => {
	const { formatMessage } = useIntl();

	return (
		<SectionWrapper
			// TODO remove SectionWrapper once @atlaskit/section design gets updated
			title={formatMessage(messages.starredFiltersHeader)}
		>
			<SectionMessage appearance="warning">
				{formatMessage(messages.errorMessage, {
					link: (linkText: ReactNode[]) => (
						// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
						<Button appearance="link" spacing="none" onClick={() => window.location.reload()}>
							{linkText}
						</Button>
					),
				})}
			</SectionMessage>
		</SectionWrapper>
	);
};

// TODO remove SectionWrapper once @atlaskit/section design gets updated
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SectionWrapper = styled(Section)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	"&&& > div[data-ds--menu--heading-item='true']": {
		paddingLeft: '6px',
		color: token('color.text'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:after': {
		height: '12px',
	},
});
